if (!process.env.APP_MANIFEST) {
  throw new Error('APP_MANIFEST is required');
}

const APP_MANIFEST = process.env.APP_MANIFEST;

interface FileEmbedMeta {
  alias: 'file-embed';
  name: 'File Embed';
}

interface PDFEmbedMeta {
  alias: 'pdf-embed';
  name: 'PDF Embed';
}

type Meta = FileEmbedMeta | PDFEmbedMeta;

export const meta = {
  alias: APP_MANIFEST.alias,
  name: APP_MANIFEST.name
} as Meta;
